export default {
  common: {
    email: 'Correo electrónico',
    phone: 'Teléfono',
    phoneNumber: 'Número de teléfono',
    countrySelect: 'Seleccione el país',
    countryUnmodifiedNote: 'El país no se puede modificar después del registro',
    next: 'Siguiente',
    back: 'Volver',
    attention: 'Atención',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    modify: 'Modificar',
    ignore: 'Ignorar',
    firstName: 'Nombre',
    middleName: 'Segundo nombre',
    lastName: 'Apellido',
    gender: 'Género',
    male: 'Masculino',
    female: 'Femenino',
    birthday: 'Fecha de nacimiento',
    graphicCode: 'Código gráfico',
    emailCode: 'Código de verificación de correo electrónico',
    smsCode: 'Código SMS',
    smsVerificationCode: 'Código de verificación por SMS',
    bind: 'Vincular',
    send: 'Enviar',
    resend: 'Reenviar',
    address: 'Dirección',
    done: 'Listo',
    systemMessage: 'Mensaje del sistema',
    setting: 'Configuración',
    submit: 'Enviar',
    language: 'Idioma',
    edit: 'Editar',
    delete: 'Eliminar'
  },
  account: {
    account: 'Cuenta',
    nickname: 'Apodo',
    id: 'ID',
    basicInfo: 'Nivel básico',
    placeholder: 'Por favor ingrese',
    completed: 'Completado',
    semiInfo: 'Semi-verificado',
    fullyInfo: 'Totalmente verificado',
    basicTab: 'Básico',
    advancedTab: 'Avanzado',
    linkedAccount: 'Cuenta de retiro vinculada',
    accountSecurity: 'Cuenta y seguridad de MetWallet',
    logout: 'Cerrar sesión',
    semiToast: 'Por favor complete la verificación de nivel básico',
    fullyToast: 'Por favor complete la verificación de nivel básico y semi-verificada',
    quickLoginTitle: 'Inicio de sesión rápido',
    cancelQuickLogin: 'Estás seguro de deshabilitar el inicio de sesión rápido?'
  },
  accountSecurity: {
    title: 'Cuenta y seguridad',
    payPwd: 'Contraseña de pago',
    loginPwd: 'Contraseña de inicio de sesión',
    changeEmail: 'Cambiar correo electrónico',
    changePhone: 'Cambiar número de teléfono',
    changePayPwd: 'Cambiar contraseña de pago',
    changeLoginPwd: 'Cambiar contraseña de inicio de sesión',
    bindEmail: 'Vincular correo electrónico',
    bindEmailNote: 'Pase la verificación de correo electrónico para vincularlo',
    bindEmailPlaceholder: 'Introduzca el correo electrónico que desea vincular',
    smsBindNote: 'Pasar la verificación por SMS para vincularlo',
    bindPhone: 'Vincular número de teléfono',
    smsAuthentication: 'Autenticación por SMS',
    emailAuthentication: 'Autenticación por correo electrónico',
    phoneVerificationNote: 'Primero apruebe la verificación del número de teléfono actual',
    bindPhonePlaceholder: 'Ingrese el número de teléfono que desea vincular',
    verificationWrongToast: 'Verifique su código de verificación',
    phoneNumberEmptyToast: 'Complete el número de teléfono',
    verificationCodeEmptyToast: 'Complete el código',
    wrongCodeToast: 'Código incorrecto',
    changeNote: 'Pase la verificación para cambiarla.',
    newEmailVerification: 'Verificación de nuevo correo electrónico',
    newEmailPlaceholder: 'Ingrese su nuevo correo electrónico',
    change: 'Cambiar',
    emailLowercaseToast: 'El correo electrónico debe estar en minúsculas.',
    newEmailEmptyToast: 'Por favor, rellene el nuevo correo electrónico',
    changeSuccessToast: 'Cambio exitoso',
    phonePlaceholder: 'Ingrese el teléfono',
    currentEmail: 'Correo electrónico actual',
    passCurrentEmailVerificationFirst: 'Primero, pase la verificación de correo electrónico actual',
    currentEmailVerification: 'Verificación de correo electrónico actual',
    smsVerification: 'Verificación por SMS',
    currentPhoneNumber: 'Número de teléfono actual',
    currentPhoneVerification: 'Verificación de teléfono actual',
    currentEmailAddress: 'Dirección de correo electrónico actual',
    phoneVerification: 'Verificación telefónica',
    enterVerificationCode: 'Ingrese el código de verificación',
    newPhoneNumber: 'Nuevo número de teléfono',
    newEmail: 'Nuevo correo electrónico'
  },
  withdrawAccount: {
    selectAccountType: 'Seleccionar tipo de cuenta',
    noBasicLevelVerificationDialog:
      'Por favor complete la verificación de nivel básico antes de vincular el método de retiro.',
    bindNote: 'Por favor, rellene la información de cuenta correcta o su retiro se verá afectado.',
    bindBankAccount: 'Vincular cuenta bancaria',
    bindMobileMoneyAccount: 'Vincular cuenta de dinero móvil',
    fieldEmptyToast: '{0} es obligatorio',
    fieldLengthToast: 'El {0} debe contener al menos {1} caracteres',
    bindBankRepeatToast: '¡No vincule la misma cuenta bancaria repetidamente!',
    accountName: 'Nombre de la cuenta',
    ifscCode: 'Código IFSC',
    accountEmptyToast: 'Se requiere la cuenta',
    accountNameEmptyToast: 'Se requiere el nombre de la cuenta',
    phoneEmptyToast: 'Se requiere el teléfono',
    emailEmptyToast: 'Se requiere el correo electrónico',
    ifscCodeEmptyToast: 'Se requiere el código IFSC',
    ifscCodeLengthToast: 'El código IFSC debe tener 11 dígitos',
    bindIMPSRepeatToast: '¡No vincule la misma cuenta IMPS repetidamente!',
    bindNote2:
      'Complete su dirección TRC-20 correcta. Una dirección incorrecta provocará la pérdida del pago, de lo cual no nos hacemos responsables.',
    usdtAddress: 'Dirección USDT (TRC-20):',
    minimumLimit: 'Mínimo de retiro por transacción: $10',
    usdtFee: 'Tarifa: Sujeta a las tarifas reales',
    registerGcash: 'Si no tiene una cuenta Gcash, haga clic aquí para registrarse.',
    registerEpay: 'Si no tiene una cuenta Epay, haga clic aquí para registrarse.',
    bindThirdPartyTitle: 'Vincular cuenta {0}',
    wrongAccountToast: 'Cuenta incorrecta',
    accountFormatToast: 'El formato de la cuenta es incorrecto',
    bindThirdPartyFailedToast: 'La vinculación de {0} falló',
    queryFailedToast: 'Consulta fallida.',
    editFailedToast: 'Error al editar.',
    add: 'Agregar',
    confirmEditDialog: '¿Está seguro de editar la cuenta {0}?',
    payPwdRequireDialog: 'Establezca una contraseña de pago de 6 dígitos antes de agregar una cuenta.',
    unbindFailedToast: 'Error al desvincular',
    cashOutSuccessNote: 'Tiempo estimado de llegada: dentro de 7 días hábiles',
    requestSubmitted: 'Solicitud de retiro enviada',
    amountLimitToast1: 'El monto del retiro de efectivo debe ser ≥$40.00',
    // eslint-disable-next-line no-template-curly-in-string
    amountLimitToast2: 'El monto del retiro de efectivo debe ser ≥${0}.00',
    recommendAmountNote:
      // eslint-disable-next-line no-template-curly-in-string
      'Consejos: Acumular el monto a ${0} antes de retirar le ahorrará efectivamente sus tarifas de procesamiento.',
    amountNotEnoughToast: 'El monto del retiro de efectivo no es suficiente',
    exceedingLimitToast1: 'El monto del retiro de efectivo de hoy ha alcanzado el límite superior',
    exceedingLimitToast2:
      'El monto del retiro de efectivo de hoy ha alcanzado el límite superior. ¿Necesita completar la certificación avanzada para aumentar el límite?',
    restrictedCountriesPayPalAccountToast:
      'No use una cuenta de PayPal de un país restringido, ya que esto hará que su Arripay se bloquee',
    withdrawMinimumToast: 'Mínimo de retiro por transacción: $40',
    bankNotAvailableToast: 'Este banco ya no está disponible, por favor, contacte con otros bancos.',
    usdtAccountInvalidToast:
      'No es posible realizar retiros en esta cuenta USDT. Utilice una nueva cuenta para realizar retiros.',
    noPayPwdToast: 'Establezca una contraseña de pago de 6 dígitos antes de realizar el retiro.',
    editBankAccount: 'Editar cuenta bancaria',
    accountPlaceholder: 'Ingrese su cuenta',
    trc20Placeholder: 'Ingrese la dirección TRC-20',
    accountRepeatToast: 'La misma que la actual.',
    unbindBankCardConfirmDialog: '¿Está seguro de desvincular la tarjeta bancaria {0}?',
    unbindMobileMoneyAccountConfirmDialog: '¿Está seguro de desvincular la cuenta de dinero móvil {0}?',
    unbindAccountConfirmDialog: '¿Está seguro de desvincular la cuenta {0}?',
    availableBalance: 'Saldo disponible {0}',
    estimatedFee: 'Tarifa estimada',
    submitFailToast: 'Enviar fallido',
    disabledMethodToast: 'Este canal no está disponible temporalmente',
    channelUnavailableTitle: 'Canal no disponible',
    channelUnavailableNote: 'Este canal de retiro no está disponible temporalmente. Pruebe otra forma.',
    channelUnavailableOk: 'OK',
    bankTransferUnavailableTitle: 'Transferencia bancaria no disponible',
    bankTransferUnavailableNote:
      'La transferencia bancaria no está disponible para tu cuenta en este momento. Usa Epay para retirar.',
    channelMaintenanceTitle: 'Canal en mantenimiento',
    channelMaintenanceNote: 'Este canal de retiro está en mantenimiento. Pruebe otra forma.',
    bankInfoUpdateTitle: 'Actualiza tu información bancaria',
    bankInfoUpdateNote: 'Debido al ajuste de política del banco, actualiza tus datos bancarios para continuar.',
    bindEpay: 'Vincular Epay',
    useEpay: 'Usar Epay',
    iMPSMaxLimitToast: 'El monto máximo de retiro para una sola transacción a través de este canal es de $260',
    linkedAccount: 'Cuenta agregada',
    otherAccounts: 'Se pueden agregar otras cuentas',
    withdrawTo: 'Transferir a',
    withdrawAmount: 'Monto de transferencia',
    withdrawable: 'Retirable',
    documentIdToast: 'El número de identificación solo puede contener números',
    noAvailableMethodNote: 'No hay método de retiro disponible',
    recommended: 'Recomendado'
  },
  paymentCode: {
    changePayPwd: 'Cambiar contraseña de pago',
    setPayPwd: 'Establecer contraseña de pago',
    setPayPwdNote: 'Establezca una contraseña de pago de 6 dígitos',
    reenterPayPwdNote: 'Introduzca nuevamente',
    verificationNote: 'Pase la verificación para establecerla.',
    emailVerification: 'Verificación de correo electrónico',
    inconsistentPasswordToast: 'Contraseña inconsistente',
    payPwdNote: 'Ingrese la contraseña de pago',
    payPwdFormatToast: 'La contraseña de pago es un número de 6 dígitos',
    payPwdWrongToast: 'Contraseña de pago incorrecta',
    payPwdVerificationFailToast: '¡Error en la verificación de la contraseña de pago!',
    successToast: 'Establecer \n correctamente'
  },
  authorize: {
    requirement:
      '{0} necesita adquirir la siguiente información de su MetWallet{1} para brindarle el servicio relacionado. Apodo, avatar, género, etc.',
    authorize: 'Autorizar',
    switchAccount: 'Cambiar cuenta',
    goToMetWallet: 'Ir a MetWallet',
    notMatchTips:
      'Operación fallida. Solo puedes habilitar el inicio de sesión rápido con tu cuenta de MetWallet vinculada'
  },
  basicLevel: {
    namePlaceholder: 'Sin símbolos ni números',
    verification: 'Verificación',
    whatsAvailable: 'Qué está disponible',
    cashOut: 'Retiro',
    withdrawLimit: '$50 por día',
    basicLevelNote:
      'Por favor, ingrese su información personal real. La información incorrecta puede causar fallo en el retiro.',
    fieldEmptyToast: 'Por favor, rellene todos los campos obligatorios.',
    successToast: 'Guardado \n correctamente',
    failToast: 'Error al guardar',
    confirmDialog:
      'Asegúrese de ingresar su información personal real. La información incorrecta puede causar fallo en el retiro.',
    birthdayFormatToast: 'Formato de campo de cumpleaños incorrecto',
    verificationCodeError: 'Error de código de verificación',
    verificationCodeEmpty: 'Código de verificación vacío',
    noEmailCodeToast: 'Obtenga el código de verificación por correo electrónico',
    checkDialogTitle: 'Verifique su información',
    checkDialogContent:
      'Para retirar con éxito, por favor verifique su información. La información incorrecta puede causar fallo en el retiro.',
    check: 'Comprobar'
  },
  semiVerified: {
    uploadPhotoId: 'Cargar documento de identidad con foto',
    photoId: 'Documento de identidad con foto',
    resubmit: 'Reenviar',
    limit: '$5,000 por día',
    uploading: 'Cargando...',
    notUploadProofToast: 'Cargue un comprobante de documento de identidad'
  },
  fullyVerified: {
    frontOfId: 'Frente del ID',
    backOfId: 'Reverso del ID',
    uploadIdFront: 'Subir frente del ID',
    uploadIdBack: 'Subir reverso del ID',
    withdrawDailyHint: 'Complete la información para retirar > {0} al día.',
    notUploadIdToast: 'Suba el frente y el reverso de su ID',
    proofTitle: 'DOCUMENTO DE PRUEBA DE RESIDENCIA',
    acceptableProof: 'UNA PRUEBA DE RESIDENCIA ACEPTABLE ES:',
    acceptableProof1: 'Un extracto bancario.',
    acceptableProof2: 'Una factura de servicios públicos (electricidad, agua, internet, etc.).',
    acceptableProof3:
      'Un documento emitido por el gobierno (declaración de impuestos, certificado de residencia, etc.).',
    unacceptableProof:
      'No podemos aceptar la dirección que figura en el documento de identidad que presentó como prueba de residencia válida.',
    limit: '$10,000 por día',
    notUploadToast: 'Cargue un documento de prueba de residencia',
    incorrectFormatToast: 'Cargue una imagen en formato jpg/png/jpeg.'
  },
  loginAndRegister: {
    pwd: 'Contraseña',
    lastLogin: 'Último inicio de sesión',
    moreOptions: 'Más opciones',
    agreeCheckboxContent: 'Acepte {0} y {1}',
    userAgreement: 'Acuerdo de usuario',
    privacyPolicy: 'Política de privacidad',
    notAgreeToast: 'Acepte el Acuerdo de usuario y la Política de privacidad',
    forgotPassword: 'Olvidé mi contraseña',
    linkedMail: 'Correo electrónico vinculado',
    verificationCode: 'Código de verificación',
    newPwd: 'Nueva contraseña',
    repeatPwd: 'Repetir contraseña',
    confirmPwd: 'Confirmar contraseña',
    noLinkedEmailToast: 'No hay correo electrónico vinculado con su cuenta',
    unregisteredToast: 'Este número no ha sido registrado',
    pwdFormatToast: 'El formato de la contraseña es incorrecto',
    resetSuccessToast: 'Restablecer \n correctamente',
    pwdNotMatchToast: 'Las contraseñas no coinciden dos veces',
    emailFormatToast: 'Formato de correo electrónico incorrecto',
    phoneNumberFormatToast: 'Formato de número de teléfono incorrecto',
    invalidAreaCodeToast: 'Código de área no válido',
    login: 'Iniciar sesión',
    pwdLogin: 'Iniciar sesión con contraseña',
    emailCodeLogin: 'Iniciar sesión con código de verificación de correo electrónico',
    smsLogin: 'Iniciar sesión con SMS',
    verifyEmail: 'Verificar correo electrónico',
    verifyPhone: 'Verificar teléfono',
    accountDangerDialog:
      'Se ha detectado que su cuenta está en peligro. Vuelva a verificar su cuenta; de lo contrario, no podrá seguir utilizándose.',
    sendEmailCodeDialog:
      'Le hemos enviado un código de verificación a su correo electrónico {0}. Ingrese el código de verificación.',
    sendSmsCodeDialog:
      'Le hemos enviado un código de verificación a su teléfono {0}. Ingrese el código de verificación.',
    graphicCodeEmptyToast: 'Ingrese el código gráfico.',
    countryUnselectToast: 'Primero, seleccione su país',
    unsupportedLoginTypeToast: 'Tipo de inicio de sesión no compatible',
    pwdWrongLimitOverDialog:
      'Se ha ingresado la contraseña incorrecta 3 veces. Utilice el código de verificación por SMS para iniciar sesión.',
    loginFailedToast: 'Inicio de sesión fallido',
    signIn: 'Iniciar sesión',
    pwdPlaceholder: 'Ingrese la contraseña',
    pwdNote: 'Ingrese 8-16 caracteres con letras y números',
    reenterPwdPlaceholder: 'Vuelva a ingresar la contraseña',
    reenterPwdNote: 'Vuelva a ingresar la contraseña',
    createAccount: 'Crear cuenta',
    chooseCountryNote: 'Seleccione el país',
    pwdInconsistentToast: 'No es la misma contraseña que ingresó anteriormente',
    createSuccessToast: 'Crear \n correctamente',
    registerFailToast: 'Error de registro',
    userNotExistToast: 'El usuario no existe',
    phoneIncorrectToast: 'Verifique su teléfono',
    userExistToast: 'El usuario ya existe',
    countryCodeRepeatToast: '¡No ingrese el código de país repetidamente!',
    logoutDialog: '¿Está seguro de cerrar sesión?',
    pwdRequirement: 'La contraseña debe tener al menos entre 8 y 16 caracteres con letras y números',
    signup: 'Registrarse',
    registerSuccessToast: 'Registrarse \n correctamente',
    oldPwdErrorToast: 'Verifique su contraseña anterior'
  },
  checkUserInfo: {
    title: 'Centro de administración',
    emptyInfoNote:
      'Aquí no hay información para la cuenta actual, por favor verifique la cuenta MetWallet que necesita verificar.',
    infoNote: 'Aquí está su información de verificación.',
    lastSuccessWithdrawal: 'Último retiro exitoso',
    copyBtn: 'Copiar',
    successToast: '¡Copiado exitosamente!',
    failToast: '¡Error al copiar!'
  },
  country: {
    title: 'Seleccione la región',
    popular: 'Popular'
  },
  documentDetails: {
    title: 'Detalles del documento',
    contract: 'Contrato',
    goToSign: 'Ir a firmarlo',
    download: 'Descargar',
    upload: 'Cargar',
    fileTypeLimit: 'doc., pdf., xlsx., xls., png., jpg., jpeg., solo documentos.',
    contentEmptyToast: 'Por favor, ingrese el contenido',
    placeOfBirth: 'Lugar de nacimiento',
    occupation: 'Ocupación',
    fileForm: '(Formulario de archivo)',
    proofOfAddress: 'Comprobante de domicilio en inglés',
    residenceDoc: 'Documento de residencia',
    textForm: '(Formulario de texto)',
    contractAgent: 'Agente de contratos',
    contractPayslip: 'Recibo de sueldo del contrato',
    uncompletedToast: 'Por favor, complételo para enviar',
    successToast: 'Enviar exitosamente',
    undefinedFileTypeToast: 'Tipo de carga de archivo no definido',
    uploadFailToast: 'Carga fallida'
  },
  filters: {
    amount: 'Cantidad',
    filter: 'Filtros',
    time: 'Tiempo',
    reset: 'Restablecer',
    timePickerTitle: 'Seleccionar {0} Tiempo',
    start: 'Inicio',
    end: 'Fin',
    maximum: 'Máximo',
    minimum: 'Mínimo'
  },
  home: {
    balance: 'Saldo',
    transactions: 'Transacciones',
    availableBalance: 'Saldo disponible',
    noWithdrawalMethodToast: 'Se necesita al menos un método de retiro.',
    linkAccount: 'Vincular cuenta',
    all: 'Todos',
    cashIn: 'Efectivo ingresado',
    loading: 'cargando...',
    noMore: 'No hay más transacciones',
    reload: 'Error en la carga, haga clic para recargar',
    receivedFrom: 'Recibido de',
    transferredTo: 'Transferido a',
    fee: 'Tarifa por transferencia a',
    myEmail: 'Mi correo electrónico',
    myPhone: 'Mi teléfono',
    invalidBasicLevelDialog:
      'Debido a la inclusión de símbolos, espacios o números en el campo de su nombre, no es posible realizar retiros de la cuenta. Por favor, vuelve a completar la información básica (asegúrate de que el nombre no incluya símbolos, espacios o números y si no tienes apellido o segundo nombre, déjalo en blanco).',
    lackLastNameDialog: 'Tu apellido no está completo, lo que dificultará tu retiro.',
    fillIn: 'Completar',
    viewDetails: 'Ver detalles',
    docReviewingDialogTitle: 'Por favor, espera a que se apruebe el documento.',
    docReviewingDialogContent:
      'Has enviado el documento, pero no puedes usar MetWallet antes de que se apruebe.<br>El personal oficial lo procesará pronto, por favor, espera un momento.',
    docPassedDialog: 'El documento que has enviado ha sido aprobado. <br>Ahora puedes usar MetWallet normalmente.',
    docUnqualifiedDialog: 'El documento que has enviado no está calificado. <br>Envía uno calificado.',
    goToSubmit: 'Envíalo',
    uncompletedDialog: 'Debes completarlo para usar MetWallet normalmente',
    useMetWalletNormallyAfterPassed: 'Puedes usar MetWallet normalmente después de que se apruebe el documento.',
    requireSemiVerifiedDialog:
      '{0}, por exigencia del banco, tienes que completar la parte semi-verificada en 48 horas para un retiro exitoso.',
    goToVerify: 'Verifica',
    emailInvalidDialog:
      '{0}, tu dirección de correo electrónico es la misma que la de otra persona. Para asegurar tu privacidad, ingresa tu propia dirección de correo electrónico lo antes posible.',
    later: 'Más tarde',
    transferRequireSemiVerifiedDialog: 'Complete la verificación semi-verificada antes de la transferencia.',
    modifyBtnText: 'Modificar mi información',
    unmodifiedTitle: 'No se puede modificar',
    unmodifiedContent: 'Tiene una orden de retiro en proceso. La información no se puede modificar ahora.'
  },
  signing: {
    signature: 'Firma',
    date: 'Fecha',
    employeeName: 'Nombre del empleado',
    designation: 'Cargo',
    month: 'Mes',
    year: 'Año',
    earnings: 'Ganancias',
    deductions: 'Deducciones',
    basic: 'Básico y DA (USD)',
    totalAddition: 'Total de adición',
    totalDeduction: 'Total de deducción',
    salary: 'Salario NETO',
    refNo: 'N.º de referencia',
    paymentTransferDate: 'Fecha de transferencia del pago',
    nameOfBank: 'Nombre del banco',
    signatureOfEmployee: 'Firma del empleado',
    director: 'Director',
    signNote: 'Firme con su nombre',
    preview: 'Vista previa',
    clear: 'Borrar',
    save: 'Guardar',
    noSignatureToast: 'No puede guardar sin una firma.',
    fieldEmptyToast: 'Complete toda la información.'
  },
  transactionDetail: {
    title: 'Detalle de la transacción',
    status: 'Estado',
    pending: 'Pendiente',
    completed: 'Completado',
    success: 'SUCCESS',
    failed: 'Error',
    cancelled: 'Cancelado',
    onHold: 'En espera',
    reason: 'Motivo del estado',
    description: 'Descripción',
    creationDate: 'Fecha de creación',
    lastStatusDate: 'Fecha del último estado',
    requestedAmount: 'Monto solicitado',
    receiveAmount: 'Monto recibido',
    transferAmount: 'Monto transferido',
    amountToPay: 'Monto a pagar',
    transferFee: 'Tarifa de transferencia',
    processingFee: 'Tarifa de procesamiento',
    method: 'Método',
    country: 'País',
    name: 'Nombre',
    bankPendingText: 'En revisión bancaria final',
    pendingText: 'En revisión {0}',
    chametSalary: 'Salario de Chamet',
    userSalary: 'Salario del usuario',
    comm: 'Comun.',
    gemgalaSalary: 'Salario de Gemgala'
  },
  transfer: {
    title: 'A la cuenta MetWallet',
    noPayPwdDialog: 'Establezca una contraseña de pago de 6 dígitos antes de realizar la transferencia.',
    records: 'Registros',
    cashInOut: 'Ingreso de efectivo {0}, retiro de efectivo {1}',
    transfer: 'Transferencia',
    fee: 'Tarifa',
    remark: 'Observación',
    transferTo: 'Transferir a {0}',
    remarkPlaceholder: 'Agregar observación de transferencia (menos de 100 caracteres)',
    firstNameNote: 'Por favor, ingrese su nombre',
    sendingAmount: 'Monto enviado',
    receivingAmount: 'Monto recibido',
    transferNow: 'Transferir ahora',
    noBalanceToast: 'El monto de la transferencia es mayor que el monto del saldo.',
    amountTooLittleToast: 'El monto de la transferencia no puede ser menor a $10.'
  },
  bankData: {
    beneficiaryName: 'Nombre del beneficiario',
    beneficiaryNamePlaceholder: 'Ingrese el nombre',
    beneficiaryLastname: 'Apellido del beneficiario',
    beneficiaryLastnamePlaceholder: 'Ingrese el apellido',
    bankCode: 'Código del banco',
    bankCodePlaceholder: 'Seleccione el código del banco',
    bankIFSCCode: 'Código IFSC del banco',
    bankIFSCCodePlaceholder: 'Ingrese el IFSC del banco',
    bankAccount: 'Cuenta bancaria',
    bankAccountPlaceholder: 'Ingrese la cuenta bancaria',
    email: 'Correo electrónico',
    emailPlaceholder: 'Ingrese el correo electrónico',
    phoneNumber: 'Número de teléfono',
    phoneNumberPlaceholder: 'Ingrese el número de teléfono',
    address: 'Dirección',
    addressPlaceholder: 'Ingrese la dirección',
    city: 'Ciudad',
    cityPlaceholder: 'Ingrese la ciudad',
    state: 'Estado',
    statePlaceholder: 'Ingrese el estado',
    postCode: 'Código postal',
    postCodePlaceholder: 'Ingrese el código postal',
    documentId: 'ID del documento',
    documentIdPlaceholder: 'Ingrese la ID del documento',
    nationalId: 'National ID',
    nationalIdPlaceholder: 'Enter National ID',
    individualTaxId: 'Individual Tax ID',
    individualTaxIdPlaceholder: 'Enter Individual Tax ID',
    documentType: 'Tipo de documento',
    documentTypePlaceholder: 'Seleccione el tipo de documento',
    accountType: 'Tipo de cuenta',
    accountTypePlaceholder: 'Seleccione el tipo de cuenta',
    cpfcnpjPlaceholder: 'Ingrese CPFCNPJ',
    bankBranch: 'Sucursal bancaria',
    bankBranchPlaceholder: 'Ingrese la sucursal bancaria',
    ribOfBankAccount: 'RIB de la cuenta bancaria',
    bankName: 'Nombre del banco',
    bankNamePlaceholder: 'Ingrese el nombre del banco',
    bicCode: 'Código BIC',
    bicCodePlaceholder: 'Ingrese el código BIC',
    ibanPlaceholder: 'Ingrese el IBAN',
    bankSwift: 'Swift del banco',
    bankSwiftPlaceholder: 'Ingrese el Swift del banco',
    name: 'Nombre',
    documentCountry: 'País del documento',
    documentCountryPlaceholder: 'Seleccione el país del documento',
    issueDate: 'Fecha de emisión del documento',
    issueDatePlaceholder: 'Seleccione la fecha de emisión',
    expireDate: 'Fecha de vencimiento del documento',
    expireDatePlaceholder: 'Seleccione la fecha de vencimiento',
    bankBranchName: 'Nombre de la sucursal bancaria',
    bankBranchNamePlaceholder: 'Ingrese el nombre de la sucursal',
    branchPlaceholder: 'Ingrese la sucursal',
    gender: 'Sexo',
    genderPlaceholder: 'Seleccione el sexo',
    birthday: 'Fecha de nacimiento',
    birthdayPlaceholder: 'Seleccione la fecha de nacimiento',
    phone: 'Teléfono',
    bankAddress: 'Banco Dirección',
    bankAddressPlaceholder: 'Ingrese la dirección del banco',
    bankAccountName: 'Nombre de la cuenta bancaria',
    bankAccountNamePlaceholder: 'Ingrese el nombre de la cuenta bancaria',
    province: 'Provincia',
    provincePlaceholder: 'Ingrese la provincia',
    postalCode: 'Código postal',
    postalCodePlaceholder: 'Ingrese el código postal',
    savingsAccount: 'Cuenta de ahorros',
    abaRoutingNumber: 'Número de ruta ABA',
    englandBankAccount: 'Cuenta bancaria en Inglaterra',
    bankBranch2: 'Sucursal bancaria',
    bankBranch2Placeholder: 'Solo si el banco es Santander',
    paternalName: 'Nombre paterno',
    paternalNamePlaceholder: 'Ingrese el nombre paterno',
    passportIdNumber: 'Número de identificación del pasaporte',
    bankNamePlaceholder2: 'Seleccione el nombre del banco',
    areaCode: 'Código de área',
    phoneNumberNoAreaCode: 'Número de teléfono (sin código de área)',
    idType: 'Tipo de identificación',
    idNo: 'Número de identificación',
    idIssueDate: 'Fecha de emisión de la identificación',
    idExpireDate: 'Fecha de vencimiento de la identificación',
    ibanStyleToast: "Por favor, ingrese un contenido que comience con 'SA' y tenga una longitud de 24 caracteres."
  },
  rechargeAndTransfer: {
    transfer_limit_1: 'Solo puedes transferir a vendedores de diamantes',
    search: 'Buscar',
    history: 'Usuarios transferidos',
    confirm_content: '¿Estás seguro de transferir {0} a {1}?',
    success_content: '{0} ha sido transferido a {1}',
    purchase: 'Compra',
    purchase_success: 'Has comprado {0} con éxito',
    insufficient_balance: 'Saldo insuficiente',
    purchase_diamond: 'Compra diamantes',
    transfer_limit_2: 'El monto de la transferencia debe estar entre $10 y $30,000',
    no_data: 'Sin datos',
    invalid_number: 'Ingresa un número válido',
    under_limit: 'El monto de la transferencia no debe ser menor a $10',
    over_limit: 'El monto de la transferencia debe ser menor a $30,000'
  },
  redesign: {
    emailPlaceholder: 'Ingresar dirección de correo electrónico',
    retrievePwd: 'Recuperar contraseña',
    resetPwd: 'Restablecer contraseña',
    newPwdPlaceholder: 'Ingresar nueva contraseña',
    reenterNewPwdPlaceholder: 'Reingresar nueva contraseña',
    reenterPayPwdPlaceholder: 'Por favor, vuelva a ingresar la contraseña de pago',
    sendToPhone: 'El código de verificación ha sido enviado a su teléfono',
    sendToWhatsapp: 'El código de verificación ha sido enviado a su WhatsApp',
    sendToEmail: 'El código de verificación ha sido enviado a su correo electrónico',
    invalidCode: 'Código inválido',
    userId: 'ID de usuario',
    other: 'Otro',
    transactionRecord: 'Registro de transacción',
    bankCardInfo: 'Cuenta de tarjeta bancaria',
    withdrawInfo: 'Cuenta de retiro',
    toFillIn: 'Para ser completado',
    walletInfo: 'Información de la cuenta de billetera',
    toComplete: 'Para ser completado',
    verifyGuide: 'Complete la información de la cuenta de billetera para obtener más calificaciones de retiro',
    verifyNote: 'Complete la siguiente información para obtener calificaciones de retiro diario de {0}',
    verifyCompletedNote: 'La información está completa para obtener calificaciones de retiro diario de {0}',
    continueBtnText: 'Continúe completando',
    submitInfo: 'Enviar información',
    transferAmount: 'Monto de transferencia',
    newEmailVerify: 'Nueva verificación de correo electrónico',
    verifyCodePlaceholder: 'Ingrese el código de verificación',
    emailIncorrectToast: 'Por favor, ingrese la dirección de correo electrónico correcta',
    newPhone: 'Nuevo número de teléfono',
    accountAdded: 'Información de la cuenta agregada',
    accountToAdd: 'Se pueden agregar otras cuentas',
    edit: 'Editar',
    enterPayPwd: 'Ingresar contraseña de pago',
    deleteBtnText: 'Eliminar',
    transferTo: 'Transferir a',
    withdrawable: 'Retirable',
    goSet: 'Ir a configurar',
    goModify: 'Ir a modificar'
  }
}



// WEBPACK FOOTER //
// ./src/configs/language/lang/es.js